import React from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
} from "@material-ui/core";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import InputForm from "../../../../partials/inputForm";
import MapComponent from "../../../leafletMap";
import Loading from "../../../loading";
import SelectedLangue from "../../../selectedLanguage";
import SnackbarComponent from "../../../snackbar";
import DescriptionComponent from "../../../descriptionComponent";
import { informationStyle } from "./styles";
import InputAddress from "../../../suggestAddress";
import NumberFormatCustom from "../../../numberFormat";
import { isJsonString } from "../../../../utils/setting";
class Information extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: true,
      service: {},
    };
  }
  componentWillMount() {
    this.props.onRef(null);
  }
  async componentDidMount() {
    this.props.onRef(this);
    const { service = {} } = this.props;
    this.setState({ service: service });
    if (service && service.description && this.DescriptionComponent)
      this.DescriptionComponent.changeDescription(service.description);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.service !== this.props.service ||
      nextProps.service.no !== this.props.service.no
    ) {
      const { service = {} } = nextProps;
      this.setState({ service: service });
      if (service && service.description && this.DescriptionComponent)
        this.DescriptionComponent.changeDescription(service.description);
    }
  }
  handleChange = (name, value) => {
    let service = this.state.service;
    if (name === "usingTax" || name === "pointSystem") {
      value = value ? 1 : 0;
    } else if (name === "maxPrice" || name === "minPrice") {
      value = Number(value);
    }
    service[name] = value;
    this.setState({ service });
  };
  handleChangePrice = (name, value, typePrice) => {
    let service = this.state.service;
    service[typePrice] = value;
    this.setState({ service });
  };
  handleChangeAddress = (value) => {
    let { service } = this.state;
    service = { ...service, ...value };
    this.setState({ service });
  };
  handleUpdate = () => {
    const { service = {} } = this.state;
    let { t } = this.props;
    if (!service.address)
      this.mSnackbar.handleClick(
        t("service_ownerspa_servicedetail_please_enter_address"),
        "warning"
      );
    else if (!service.lat && !service.lng)
      this.mSnackbar.handleClick(
        t("service_ownerspa_servicedetail_can_not_detect_position_on_map"),
        "warning"
      );
    else if (!service.name)
      this.mSnackbar.handleClick(
        t("service_ownerspa_servicedetail_please_enter_name"),
        "warning"
      );
    else {
      this.props.handleUpdate("information", {
        service: service,
      });
    }
  };

  onEnterAddress = (event) => {
    if (event.key === "Enter") {
      const { service = {} } = this.state;
      this.myGoogleMap.viewOnGoogleMap(service.address);
    }
  };
  render() {
    console.log("service", this.props.service)
    const { classes, t, disabled = false } = this.props;
    const { service = {} } = this.state;
    if (isJsonString(service.support))
      service.support = JSON.parse(service.support);
    if (service !== undefined && service !== "" && service !== null) {
      return (
        <div>
          <Loading
            onRef={(id) => (this.loading = id)}
            show={this.state.loading}
          />
          <SnackbarComponent
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={disabled}
                    checked={service.pointSystem === 1 ? true : false}
                    onChange={(e) =>
                      this.handleChange(e.target.name, e.target.checked)
                    }
                    name="pointSystem"
                    color="primary"
                  />
                }
                label={t("service_ownerspa_servicedetail_feature_point_system")}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={disabled}
                    checked={service.usingTax === 1 ? true : false}
                    onChange={(e) =>
                      this.handleChange(e.target.name, e.target.checked)
                    }
                    name="usingTax"
                    color="primary"
                  />
                }
                label={t("service_ownerspa_servicedetail_feature_using_tax")}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                label={t("service_ownerspa_servicedetail_feature_name")}
                name="name"
                // margin="none"
                value={service.name || ""}
                onChange={(e) =>
                  this.handleChange(e.target.name, e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                id="phone"
                label={t("service_ownerspa_servicedetail_feature_phone")}
                name="phone"
                // margin="none"
                value={service.phone || ""}
                onChange={(e) =>
                  this.handleChange(e.target.name, e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                id="mobile"
                label={t("service_ownerspa_servicedetail_feature_mobile")}
                name="mobile"
                // margin="none"
                value={service.mobile || ""}
                onChange={(e) =>
                  this.handleChange(e.target.name, e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                id="minPrice"
                name="minPrice"
                label={t("service_ownerspa_servicedetail_feature_min_price")}
                // margin="none"
                value={service.minPrice || ""}
                onChange={(e) =>
                  this.handleChangePrice(
                    e.target.name,
                    e.target.value,
                    "minPrice"
                  )
                }
                InputProps={{
                  inputComponent: NumberFormatCustom,
                  endAdornment: (
                    <InputAdornment position="end">
                      {this.props.currencyCode}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                id="maxPrice"
                label={t("service_ownerspa_servicedetail_feature_max_price")}
                name="maxPrice"
                // margin="none"
                value={
                  service.maxPrice === null
                    ? (service.maxPrice = "")
                    : service.maxPrice
                }
                onChange={(e) =>
                  this.handleChangePrice(
                    e.target.name,
                    e.target.value,
                    "maxPrice"
                  )
                }
                InputProps={{
                  inputComponent: NumberFormatCustom,
                  endAdornment: (
                    <InputAdornment position="end">
                      {this.props.currencyCode}
                    </InputAdornment>
                  ),
                  // className: classes.input
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputForm
                disabled={disabled}
                id="currency"
                label={t("service_ownerspa_servicedetail_feature_currency")}
                name="currencyCode"
                // margin="none"
                // defaultValue={this.props.currencyCode}
                value={this.props.currencyCode}
                onChange={(e) =>
                  this.handleChange(e.target.name, e.target.value)
                }
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <InputForm
                disabled={disabled}
                name="website"
                id="website"
                label="Website"
                value={service.website || ""}
                onChange={(e) =>
                  this.handleChange(e.target.name, e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} className={classes.supportContainer}>
              <SelectedLangue
                disabled={disabled}
                support={service.support}
                handleSubComponentChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputAddress
                disabled={disabled}
                name="address"
                label={t("service_ownerspa_servicedetail_feature_address")}
                onKeyPress={this.onEnterAddress}
                value={service.address || ""}
                handleChange={this.handleChangeAddress}
                InputProps={{
                  classes: {
                    input: classes.inputMultiline,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InputForm
                disabled
                label={t("service_ownerspa_servicedetail_feature_country")}
                name="country"
                value={service.country || ""}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InputForm
                disabled
                label={t("service_ownerspa_servicedetail_feature_state")}
                name="state"
                value={service.state || ""}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InputForm
                disabled
                label={t("service_ownerspa_servicedetail_feature_city")}
                name="city"
                value={service.city || ""}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <InputForm
                disabled
                label={t("service_ownerspa_servicedetail_feature_district")}
                value={service.district || ""}
                name="district"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} id="google-map-component">
            <Grid item xs={12} sm={12} md={12}>
              <MapComponent
                onRef={(googleMap) => (this.myGoogleMap = googleMap)}
                handleChangeAddress={this.handleChangeAddress}
                handleOpenSnackBar={this.props.handleOpenSnackBar}
                lat_center={Number(service.lat)}
                lng_center={Number(service.lng)}
              />
            </Grid>
          </Grid>
          {/* <Grid container spacing={3} className={classes.description}> */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <DescriptionComponent
                disabled={disabled}
                onRef={(id) => (this.DescriptionComponent = id)}
                title={t("service_ownerspa_servicedetail_feature_description")}
                handleSubComponentChange={this.handleChange}
                description={this.state.service.description}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={12} className={classes.buttonContainer}>
              <Button
                disabled={disabled}
                onClick={this.handleUpdate}
                color="primary"
                size="large"
                variant="contained"
                component="span"
                className={classes.button}
              >
                {t("service_ownerspa_servicedetail_update")}
              </Button>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return (
        <div>
          <Loading
            onRef={(id) => (this.loading = id)}
            show={this.state.loading}
          />
          <SnackbarComponent
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
        </div>
      );
    }
  }
}

Information.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(informationStyle, { withTheme: true })(Information)
  )
);
